module.exports = __webpack_public_path__ + "img/info.c176a2d5.svg";